import React, { useContext, useState } from "react";
import { EditorContext, RicosContext } from "./../../ricos-context";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../ricos-modals/modal-service-provider";
import { ToggleButton } from "./../../toolbars-ui";
import { HTML_BUTTONS } from "../consts";
import { SliderModal } from "./SliderModal";
const DimensionSliderButton = ({
  toolbarItem,
  dimension,
  dataHook,
  min,
  max,
  defaultValue
}) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(HTML_BUTTONS[dimension]));
  const { icon, tooltip } = toolbarItem.presentation;
  const node = toolbarItem.attributes.selectedNode;
  const { getEditorCommands } = useContext(EditorContext);
  const getComponentData = () => {
    const nodeId = node?.attrs.id;
    return getEditorCommands().getBlockComponentData(nodeId) || {};
  };
  const getValue = () => getComponentData().containerData?.[dimension]?.custom;
  const onChange = (value) => {
    const componentData = getComponentData();
    const containerData = {
      ...componentData.containerData,
      [dimension]: {
        custom: value
      }
    };
    setTimeout(() => {
      toolbarItem.commands?.click({ value, data: { ...componentData, containerData } });
    }, 0);
  };
  const onClick = () => {
    if (modalService?.isModalOpen(HTML_BUTTONS[dimension])) {
      modalService.closeModal(HTML_BUTTONS[dimension]);
    } else {
      const componentProps = {
        onChange,
        min,
        max,
        value: getValue() || defaultValue
      };
      modalService.openModal({
        Component: SliderModal,
        id: HTML_BUTTONS[dimension],
        componentProps,
        layout: "popover",
        positioning: { referenceElement, placement: "bottom" }
      });
    }
  };
  return /* @__PURE__ */ React.createElement("div", { ref: setReferenceElement }, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      active: isModalOpen,
      Icon: icon,
      onClick,
      dataHook,
      tooltip: t(tooltip)
    }
  ));
};
export {
  DimensionSliderButton
};
//# sourceMappingURL=DimensionSliderButton.js.map
